
import { defineComponent } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'

export default defineComponent({
    components: {
        loader: Loader,
    },
    props: {
        accept: {
            type: String,
            default: 'image/*',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['file-loaded'],
    setup(props, { emit }) {
        const emitUpdate = (event: InputEvent) => {
            const target = event.target as HTMLInputElement
            const files = target.files

            const array_of_files: File[] = []
            if (!files || !files.length) return array_of_files

            for (let index = 0; index < files.length; index++) {
                const file = files.item(index)
                if (!file) continue
                array_of_files.push(file)
            }

            emit('file-loaded', array_of_files)
            target.value = ''
        }

        return { emitUpdate }
    },
})
